import { takeLatest, put, call, all, select, take } from "redux-saga/effects";
import camelize from "camelize";

import {
  FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_FAILED,
  FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_REQUESTED,
  FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_FAILED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_REQUESTED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_SUCCEEDED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_FAILED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_REQUESTED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_SUCCEEDED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_FAILED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_REQUESTED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_FAILED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_REQUESTED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_SUCCEEDED,
  FETCH_STUDENT_ENGAGEMENT_COUNT_FAILED,
  FETCH_STUDENT_ENGAGEMENT_COUNT_REQUESTED,
  FETCH_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_STUDENT_ENGAGEMENT_DATA_FAILED,
  FETCH_STUDENT_ENGAGEMENT_DATA_REQUESTED,
  FETCH_STUDENT_ENGAGEMENT_DATA_SUCCEEDED,
  FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_FAILED,
  FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_REQUESTED,
  FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_REQUESTED2,
  FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_SUCCEEDED,
  FETCH_STUDENT_PROFICIENT_LVL_2_DATA_FAILED,
  FETCH_STUDENT_PROFICIENT_LVL_2_DATA_REQUESTED,
  FETCH_STUDENT_PROFICIENT_LVL_2_DATA_REQUESTED2,
  FETCH_STUDENT_PROFICIENT_LVL_2_DATA_SUCCEEDED,
  FETCH_TEACHER_ENGAGEMENT_COUNT_FAILED,
  FETCH_TEACHER_ENGAGEMENT_COUNT_REQUESTED,
  FETCH_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_TEACHER_ENGAGEMENT_DATA_FAILED,
  FETCH_TEACHER_ENGAGEMENT_DATA_REQUESTED,
  FETCH_TEACHER_ENGAGEMENT_DATA_SUCCEEDED,
  GET_ME_FAILED,
  GET_ME_REQUESTED,
  GET_ME_SUCCEEDED,
  GET_USER_REFRESH_FAILED,
  GET_USER_REFRESH_REQUESTED,
  GET_USER_REFRESH_SUCCEEDED,
  INIT_APP,
  initApp as mkInitApp,
  getMe as mkGetMe,
  loginUser as mkLoginUser,
  userLoggedOut as mkUserLoggedOut,
  fetchMinistryDashboardOverviewData as mkFetchMinistryDashboardOverviewData,
  fetchTeacherEngagementCount as mkFetchTeacherEngagementCount,
  fetchTeacherEngagementData as mkFetchTeacherEngagementData,
  fetchStudentEngagementCount as mkFetchStudentEngagementCount,
  fetchStudentEngagementData as mkFetchStudentEngagementData,
  fetchStudentProficientLvlTwoCount as mkFetchStudentProficientLvlTwoCount,
  fetchStudentProficientLvlTwoData as mkFetchStudentProficientLvlTwoData,
  fetchMinistryTotalQuestionsAttemptCount as mkFetchMinistryTotalQuestionsAttemptCount,
  fetchMinistryTotalQuestionsAttemptData as mkFetchMinistryTotalQuestionsAttemptData,
  fetchMinistryStudentImprovementCount as mkFetchMinistryStudentImprovementCount,
  fetchMinistryStudentImprovementData as mkFetchMinistryStudentImprovementData,
  fetchStudentDashboardOverviewData as mkFetchStudentDashboardOverviewData,
  fetchStudentDashboardOverviewDataRoundTwo as mkFetchStudentDashboardOverviewDataRoundTwo,
  fetchStudentTimeChartData as mkFetchStudentTimeChartData,
  fetchStudentQuestionCompletionChartData as mkFetchStudentQuestionCompletionChartData,
  fetchStudentQuestionCompletionChartData2 as mkFetchStudentQuestionCompletionChartData2,
  fetchStudentImprovementChartData as mkFetchStudentImprovementChartData,
  fetchStudentImprovementChartData2 as mkFetchStudentImprovementChartData2,
  fetchStudentPracticeReportQuestions as mkFetchStudentPracticeReportQuestions,
  fetchStudentImprovementReportQuestions as mkFetchStudentImprovementReportQuestions,
  fetchTeacherDashboardOverviewData as mkFetchTeacherDashboardOverviewData,
  fetchTeacherDashboardStudentPracticeReportQuestions as mkFetchTeacherDashboardStudentPracticeReportQuestions,
  fetchTeacherDashboardStudentImprovementReportQuestions as mkFetchTeacherDashboardStudentImprovementReportQuestions,
  fetchPrincipalDashboardOverviewData as mkFetchPrincipalDashboardOverviewData,
  fetchPrincipalDashboardStudentImprovementReportQuestions as mkFetchPrincipalDashboardStudentImprovementReportQuestions,
  fetchPrincipalDashboardStudentPracticeReportQuestions as mkFetchPrincipalDashboardStudentPracticeReportQuestions,
  fetchDistrictSchools as mkFetchDistrictSchools,
  fetchDistricts as mkFetchDistricts,
  FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED,
  FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_FAILED,
  FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_REQUESTED,
  FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_SUCCEEDED,
  FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_FAILED,
  FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_REQUESTED,
  FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED,
  FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_FAILED,
  FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_REQUESTED,
  FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_REQUESTED,
  FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_SUCCEEDED,
  FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_FAILED,
  FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_REQUESTED,
  FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_SUCCEEDED,
  FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_FAILED,
  FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_REQUESTED,
  FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_SUCCEEDED,
  FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_FAILED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_FAILED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_REQUESTED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_SUCCEEDED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_FAILED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_REQUESTED,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_SUCCEEDED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_REQUESTED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_SUCCEEDED,
  FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_FAILED,
  INIT_MOE_DASHBOARD,
  FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
  FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_FAILED,
  FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_REQUESTED,
  FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_REQUESTED,
  FETCH_STUDENT_TIME_DATA_SUCCEEDED,
  FETCH_STUDENT_TIME_DATA_FAILED,
  FETCH_STUDENT_QUESTION_COMPLETION_DATA_SUCCEEDED,
  FETCH_STUDENT_QUESTION_COMPLETION_DATA_FAILED,
  FETCH_STUDENT_IMPROVEMENT_DATA_SUCCEEDED,
  FETCH_STUDENT_IMPROVEMENT_DATA_FAILED,
  FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_SUCCEEDED,
  FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_FAILED,
  FETCH_STUDENT_TIME_DATA_REQUESTED,
  FETCH_STUDENT_QUESTION_COMPLETION_DATA_REQUESTED,
  FETCH_STUDENT_IMPROVEMENT_DATA_REQUESTED,
  FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_REQUESTED,
  FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED,
  FETCH_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED,
  FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED,
  FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED,
  FETCH_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED,
  FETCH_STUDENT_TRIES_QUESTIONS_DATA_FAILED,
  FETCH_STUDENT_TIME_CHART_DATA_SUCCEEDED,
  FETCH_STUDENT_TIME_CHART_DATA_FAILED,
  FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_SUCCEEDED,
  FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_FAILED,
  FETCH_STUDENT_IMPROVEMENT_CHART_DATA_SUCCEEDED,
  FETCH_STUDENT_IMPROVEMENT_CHART_DATA_FAILED,
  FETCH_STUDENT_TIME_CHART_DATA_REQUESTED,
  FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_REQUESTED,
  FETCH_STUDENT_IMPROVEMENT_CHART_DATA_REQUESTED,
  INIT_STUDENT_DASHBOARD,
  FETCH_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED,
  FETCH_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
  FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
  FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED,
  FETCH_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED,
  FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED,
  INIT_TEACHER_DASHBOARD,
  FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_REQUESTED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_REQUESTED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_REQUESTED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_REQUESTED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED,
  FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_REQUESTED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED,
  FETCH_STUDENT_LIST_DROPDOWN_SUCCEEDED,
  FETCH_STUDENT_LIST_DROPDOWN_FAILED,
  FETCH_STUDENT_LIST_DROPDOWN_REQUESTED,
  INIT_PRINCIPAL_DASHBOARD,
  FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED,
  GET_USER_LOGIN_FAILED,
  GET_USER_LOGIN_SUCCEEDED,
  GET_USER_LOGIN_REQUESTED,
  GET_USER_PASSWORD_LINK_FAILED,
  GET_USER_PASSWORD_LINK_SUCCEEDED,
  GET_USER_PASSWORD_LINK_REQUESTED,
  RESET_PASSWORD_FAILED,
  RESET_PASSWORD_SUCCEEDED,
  RESET_PASSWORD_REQUESTED,
  GET_CHANGE_PASSWORD_SUCCEEDED,
  GET_CHANGE_PASSWORD_FAILED,
  VERIFY_RESET_CODE_FAILED,
  VERIFY_RESET_CODE_SUCCEEDED,
  VERIFY_RESET_CODE_REQUESTED,
  GET_CHANGE_PASSWORD_REQUESTED,
  USER_LOGGED_OUT_SUCCEEDED,
  USER_LOGGED_OUT,
  GET_USER_LOGOUT_SUCCEEDED,
  GET_USER_LOGOUT_FAILED,
  GET_USER_LOGOUT_REQUESTED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED,
  INIT_PISA_DISTRICT_ADMIN_REPORT,
  FETCH_DISTRICT_SCHOOLS_SUCCEEDED,
  FETCH_DISTRICT_SCHOOLS_FAILED,
  FETCH_DISTRICT_SCHOOLS_REQUESTED,
  FETCH_DISTRICTS_REQUESTED,
  FETCH_DISTRICTS_SUCCEEDED,
  FETCH_DISTRICTS_FAILED,
  INIT_PISA_COUNTRY_ADMIN_REPORT,
  DOWNLOAD_DISTRICT_DATA_SUCCEEDED,
  DOWNLOAD_DISTRICT_DATA_FAILED,
  DOWNLOAD_DISTRICT_DATA_REQUESTED,
  DOWNLOAD_PAGINATION_DATA_REQUESTED,
  DOWNLOAD_PAGINATION_DATA_SUCCEEDED,
  DOWNLOAD_PAGINATION_DATA_FAILED,
  DOWNLOAD_ALL_MOE_REPORTS_REQUESTED,
  DOWNLOAD_ALL_MOE_REPORTS_SUCCEEDED,
  DOWNLOAD_ALL_MOE_REPORTS_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_REQUESTED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_REQUESTED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_REQUESTED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED,
  FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED,
  FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_SUCCEEDED,
  FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_FAILED,
  FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_REQUESTED2,
  FETCH_STUDENT_IMPROVEMENT_CHART_DATA_REQUESTED2,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_REQUESTED2,
  FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_REQUESTED2,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_REQUESTED2,
  FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_REQUESTED2,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED2,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED2,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED2,
  FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED2,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED2,
  FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED2,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED2,
  FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED2,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED2,
  FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED2,
  FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED2,
} from "./action";

import API from "./api";
import { getUserSession, selectAllSubjects } from "./selector";

import { parseQuestionResponse, b64DecodeUnicode } from "./utils";

export const JWT_TOKEN = "cerebry-jwt-token";
export const JWT_REFRESH = "cerebry-jwt-refresh";
export const PISA_ROLE = "cerebry-pisa-role";
export const IS_PISA_MOE_SUPER_ADMIN = "cerebry-pisa-super-admin";
export const BASE_ROUTE = '/';
export const RESET_PAGE = '/reset';
export const LOGIN_PAGE = '/login';
export const PISA_SCHOOLS = "/pisa-schools";
export const PISA_DISTRICT_ADMIN = "/pisa-district-admin";
export const MINISTRY_REPORT = "/ministry-report";
export const PRINCIPAL_REPORT = "/principal-report";
export const TEACHER_REPORT = "/teacher-report";
export const STUDENT_REPORT = "/student-report";
export const MINISTRY_LOGIN= "https://reports.cerebry.co/login";
export const TEACHER_LOGIN = "https://teacher.cerebry.co/login";
export const STUDENT_LOGIN = "https://student.cerebry.co/login";

export const getSavedJWT = (jwtKey) => {
  return Cookies.get(jwtKey);
};

const getPathName = (key) => {
  return location.pathname.indexOf(key) > -1 ? true : false;
};

export const saveJWT = (jwtKey, jwtValue) => {
  if (location.hostname === "localhost") {
    Cookies.set(jwtKey, jwtValue);
  } else {
    Cookies.set(jwtKey, jwtValue, { expires: 30, domain: "cerebry.co" });
  }
};

export const removeJWT = (jwtKey) => {
  Cookies.remove(jwtKey);
};

const handleAuthFallback=(historyRoute)=>{
  const pisa_role = localStorage.getItem(PISA_ROLE)==='pisa_moe_user';
  const isPrincipalReport = getPathName(PRINCIPAL_REPORT);
  const isTeacherReport = getPathName(TEACHER_REPORT);
  const isStudentReport = getPathName(STUDENT_REPORT);
  removeJWT(JWT_TOKEN);
  removeJWT(JWT_REFRESH);
  API.removeAccessToken();
  localStorage.removeItem(PISA_ROLE);
  localStorage.removeItem(IS_PISA_MOE_SUPER_ADMIN);
  if(isPrincipalReport)
  {
    if(pisa_role)
    {
      historyRoute.push("/login");
    }
    else
    window.location.href= TEACHER_LOGIN;
  }
  else if(isStudentReport)
  {
    window.location.href=STUDENT_LOGIN;
  }
  else if(isTeacherReport)
  {
    window.location.href=TEACHER_LOGIN;
  }
  else
  {
    historyRoute.push("/login");
  }
}

const getUserRoles=(userGroups)=>{
  const isMinistryReport = getPathName(MINISTRY_REPORT);
  const isPrincipalReport = getPathName(PRINCIPAL_REPORT);
  const isTeacherReport = getPathName(TEACHER_REPORT);
  const isStudentReport = getPathName(STUDENT_REPORT);

  if(isMinistryReport)
  {
    return "moe";
  }
  else if(isPrincipalReport)
  {
    return "principal";
  }
  else if(isStudentReport)
  {
    return "student"
  }
  else if(isTeacherReport)
  {
    return "teacher";
  }
  else
  {
    if(userGroups.length>0)
    {
      if(userGroups.some(i=>i==='pisa_moe_user'))
      {
        return "moe"
      }
      if(userGroups.some(i=>i==='pisa_country_admin'))
      {
        return "country_admin"
      }
      if(userGroups.some(i=>i==='pisa_district_admin'))
      {
        return "district_admin"
      }
    }
    else
    {
      const role = localStorage.getItem(PISA_ROLE);
      if(role === 'pisa_moe_user')
        return 'moe';
      else if(role === 'pisa_country_admin')
        return 'country_admin'
      else if(role === 'district_admin')
        return 'district_admin'
      else
        return ''
    }
  }
}

function* getMe(action) {
  const userSess = yield select(getUserSession);
  let userGroups = userSess && userSess.user && userSess.user.groups || [];
  const queryParams = new URLSearchParams(window.location.search);
  const schoolId = queryParams.get("school_id");
  try {
    const role = getUserRoles(userGroups);
    if(schoolId) API.setPrincipalSchoolId(schoolId);
    const resp = yield call(API.getMe,role);
    if (resp.status >= 400) {
      yield put({
        type: GET_ME_FAILED,
        resp: camelize(resp),
      });
      if(resp.status != 401) {
        yield put(mkUserLoggedOut(action.history));
      }
      else
      {
        handleAuthFallback(action.history);
      }
    } else {
      saveJWT(JWT_TOKEN, resp.data.jwt);
      saveJWT(JWT_REFRESH, resp.data.jwt_refresh);
      API.check401('jwt ' + resp.data.jwt_refresh);
      yield put({
        type: GET_ME_SUCCEEDED,
        resp: camelize(resp),
      });
      const urlParams = new URLSearchParams(window.location.search);
      const isBASERoute = location.pathname === BASE_ROUTE;
      const isMinistryReport = getPathName(MINISTRY_REPORT);
      const isTeacherReport = getPathName(TEACHER_REPORT);
      const isStudentReport = getPathName(STUDENT_REPORT);
      userGroups = userGroups.length === 0 ? resp.data.groups : userGroups;
      const isMOE = userGroups.some(i=>i==='pisa_moe_user');
      const isSuperAdmin = userGroups.some(i=>i==='pisa_country_admin');
      const isMOESuperAdmin = isMOE && isSuperAdmin;
      if(isMOE || isMOESuperAdmin)
      {
        if(isTeacherReport || isStudentReport)
        handleAuthFallback(action.history);
        else
        {
          localStorage.removeItem(PISA_ROLE);
          localStorage.removeItem(IS_PISA_MOE_SUPER_ADMIN);
          localStorage.setItem(PISA_ROLE, 'pisa_moe_user');
          localStorage.setItem(IS_PISA_MOE_SUPER_ADMIN, isMOESuperAdmin);
          if(isBASERoute)
          {
            action.history.push(`${MINISTRY_REPORT}${urlParams.has("is_demo")?`?is_demo=${urlParams.get("is_demo")}`:""}`);
          }
        }
      }
      else if(isSuperAdmin)
      {
        localStorage.removeItem(PISA_ROLE);
        localStorage.removeItem(IS_PISA_MOE_SUPER_ADMIN);
        localStorage.setItem(PISA_ROLE, 'pisa_country_admin');
        if(isBASERoute)
        {
          action.history.push(`${PISA_SCHOOLS}${urlParams.has("is_demo")?`?is_demo=${urlParams.get("is_demo")}`:""}`);
        }
      }
      else if(userGroups.some(i=>i==='pisa_district_admin'))
      {
        localStorage.removeItem(PISA_ROLE);
        localStorage.removeItem(IS_PISA_MOE_SUPER_ADMIN);
        localStorage.setItem(PISA_ROLE, 'pisa_district_admin');
        if(isBASERoute)
        {
          action.history.push(`${PISA_SCHOOLS}${urlParams.has("is_demo")?`?is_demo=${urlParams.get("is_demo")}`:""}`);
        }
      }
      else
      {
        localStorage.removeItem(PISA_ROLE);
        localStorage.removeItem(IS_PISA_MOE_SUPER_ADMIN);
        if(isMinistryReport)
         handleAuthFallback(action.history)
      }
    }
  } catch (e) {
    yield put({
      type: GET_ME_FAILED,
    });
    yield put(mkUserLoggedOut(action.history));
  }
}

function* loginUser(action) {
  const { user,history } = action;
  try {
    API.removeAccessToken();
    const resp = yield call(API.loginUser, user);
    if (resp.status >= 400) {
      yield put({
        type: GET_USER_LOGIN_FAILED,
        data: camelize(resp.data),
      });
    } else {
      yield put({
        type: GET_USER_LOGIN_SUCCEEDED,
        data: camelize(resp.data),
      });
      const userSess = yield select(getUserSession);
      const userGroups = userSess && userSess.user && userSess.user.groups || [];
      const isMOE = userGroups.some(i=>i==='pisa_moe_user');
      const isSuperAdmin = userGroups.some(i=>i==='pisa_country_admin');
      const isMOESuperAdmin = isMOE && isSuperAdmin;
    
      if(isMOE || isMOESuperAdmin)
      {
        const urlParams = new URLSearchParams(window.location.search);
        saveJWT(JWT_TOKEN, resp.data.jwt);
        saveJWT(JWT_REFRESH, resp.data.jwt_refresh);
        history.push(`${MINISTRY_REPORT}${urlParams.has("is_demo")?`?is_demo=${urlParams.get("is_demo")}`:""}`);
        yield put(mkInitApp(action.history));
      }
      else if(isSuperAdmin)
      {
        const urlParams = new URLSearchParams(window.location.search);
        saveJWT(JWT_TOKEN, resp.data.jwt);
        saveJWT(JWT_REFRESH, resp.data.jwt_refresh);
        history.push(`${PISA_SCHOOLS}${urlParams.has("is_demo")?`?is_demo=${urlParams.get("is_demo")}`:""}`);
        yield put(mkInitApp(action.history));
      }
      else
      {
        if(userGroups.some(i=>i==='pisa_district_admin'))
          {
            const urlParams = new URLSearchParams(window.location.search);
            saveJWT(JWT_TOKEN, resp.data.jwt);
            saveJWT(JWT_REFRESH, resp.data.jwt_refresh);
            history.push(`${PISA_SCHOOLS}${urlParams.has("is_demo")?`?is_demo=${urlParams.get("is_demo")}`:""}`);
            yield put(mkInitApp(action.history));
          }
      }
    }
  } catch (e) {
    yield put({
      type: GET_USER_LOGIN_FAILED,
      message: e.message,
    });
  }
}

function* initApp(action) {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const auth_tok = urlParams.get("auth_tok");
    if(auth_tok) {
      removeJWT(JWT_TOKEN);
      removeJWT(JWT_REFRESH);
    }
    else
    {
      API.check401("jwt "+getSavedJWT(JWT_REFRESH));
    }
    const jwtToken = getSavedJWT(JWT_TOKEN) || auth_tok;
    const isResetPassword = getPathName(RESET_PAGE);
    const isLoginPage = getPathName(LOGIN_PAGE);

    if (!isResetPassword) 
    {
      if (!!jwtToken && jwtToken.length > 0) {
        API.setAccessToken("jwt " + jwtToken);
        yield put(mkGetMe(action.history));
      }
      else
      {
        if(!isLoginPage)
        {
          handleAuthFallback(action.history)
        }
      }
    }
  } catch (e) {
    console.log(e.message);
  }
}

function* getUserRefresh(action) {
  const refreshToken = getSavedJWT(JWT_REFRESH); // userSession && userSession.user && userSession.user.jwt_refresh;
  try {
    if (refreshToken && refreshToken.length > 0) {
      API.setAccessToken("jwt " + refreshToken);
      const resp = yield call(API.refreshUser);
      if (resp.status < 400) {
        yield put({
          type: GET_USER_REFRESH_SUCCEEDED,
          resp: camelize(resp),
        });
        saveJWT(JWT_TOKEN, resp.data.jwt);
        API.setAccessToken("jwt " + resp.data.jwt);
        yield put(mkInitApp(action.history));
      } else {
        yield put({
          type: GET_USER_REFRESH_FAILED,
        });
        yield put(mkUserLoggedOut(action.history));
      }
    } else {
      yield put({
        type: GET_USER_REFRESH_FAILED,
      });
      yield put(mkUserLoggedOut(action.history));
    }
  } catch (e) {
    yield put({
      type: GET_USER_REFRESH_FAILED,
      message: e.message,
    });
    yield put(mkUserLoggedOut(action.history));
  }
}

function* forgotPassword(action) {
  const { user } = action;
  try {
    const resp = yield call(API.forgotPassword, user);
    if (resp.status >= 400) {
      yield put({
        type: GET_USER_PASSWORD_LINK_FAILED,
        data: camelize(resp.data),
      });
    } else {
      yield put({
        type: GET_USER_PASSWORD_LINK_SUCCEEDED,
      });
    }
  } catch (e) {
    yield put({
      type: GET_USER_PASSWORD_LINK_FAILED,
      message: e.message,
    });
  }
}

function* verifyResetCode(action) {
  const { queryParams } = action;
  try {
    const resp = yield call(API.verifyResetCode, queryParams);
    if (resp.status >= 400) {
      yield put({
        type: VERIFY_RESET_CODE_FAILED,
        data: camelize(resp.data),
      });
    } else {
      yield put({
        type: VERIFY_RESET_CODE_SUCCEEDED,
        data: resp.data
      });
    }
  } catch (e) {
    yield put({
      type: VERIFY_RESET_CODE_FAILED,
      message: e.message,
    });
  }
}

function* resetPassword(action) {
  const { userInfo } = action;
  try {
    const resp = yield call(API.resetPassword, userInfo);
    if (resp.status >= 400) {
      yield put({
        type: RESET_PASSWORD_FAILED,
        data: camelize(resp.data),
      });
    } else {
      yield put({
        type: RESET_PASSWORD_SUCCEEDED,
        data: 'success'
      });
      const userObj = {};
      userObj.username = userInfo.username;
      userObj.password = userInfo.password;
      yield put(mkLoginUser(userObj,action.history))
    }
  } catch (e) {
    yield put({
      type: RESET_PASSWORD_FAILED,
      message: e.message,
    });
  }
}

export function* changePassword(action) {
  const { newPassword, oldPassword } = action;
  try {
    const resp = yield call(API.changePassword, oldPassword, newPassword);
    if (resp.status < 400) {
      yield put({
        type: GET_CHANGE_PASSWORD_SUCCEEDED,
      });
    } else {
      yield put({
        type: GET_CHANGE_PASSWORD_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: GET_CHANGE_PASSWORD_FAILED,
      message: e.message,
    });
  }
}

export function* getUserLogout(action) {
  try {
    const resp = yield call(API.logoutUser);
    if (resp.status) {
      if (resp.status < 400) {
        yield put({
          type: GET_USER_LOGOUT_SUCCEEDED,
          resp,
        });
      } else {
        yield put({
          type: GET_USER_LOGOUT_FAILED,
          resp,
        });
      }
      yield put(mkUserLoggedOut(action.history));
    }
  } catch (e) {
    yield put({
      type: GET_USER_LOGOUT_FAILED,
      message: e.message,
    });
  }
}

function* userLoggedOut(action) {
  try {
    removeJWT(JWT_TOKEN);
    removeJWT(JWT_REFRESH);
    API.removeAccessToken();
    handleAuthFallback(action.history);
    yield put({
      type: USER_LOGGED_OUT_SUCCEEDED,
    });
  } catch (e) {
    console.log(e);
  }
}

function* initPISACountryAdminReport(dispatch) {
  try {
    yield put(mkFetchDistricts(20,0));
  } catch (e) {
    console.log(e.message);
  }
}

function* initPISADistrictAdminReport(dispatch) {
  try {
    yield put(mkFetchDistrictSchools(20,0));
  } catch (e) {
    console.log(e.message);
  }
}

function* initMOEDashboard(dispatch) {
  const allSubjects =  yield select(selectAllSubjects());
  const currentSubject = allSubjects && allSubjects[0] && allSubjects[0].subject;
  try {
    if(currentSubject)
    yield put(mkFetchMinistryDashboardOverviewData(currentSubject));
  } catch (e) {
    console.log(e.message);
  }
}

function* initStudentDashboard(dispatch) {
  const allSubjects =  yield select(selectAllSubjects());
  const currentSubjectClass = allSubjects && allSubjects[0] && allSubjects[0].classCode;
  try {
    if(currentSubjectClass)
     yield put(mkFetchStudentDashboardOverviewData(currentSubjectClass));    
     yield put(mkFetchStudentDashboardOverviewDataRoundTwo(currentSubjectClass));    
  } catch (e) {
    console.log(e.message);
  }
}

function* initTeacherDashboard(dispatch) {
  const allSubjects =  yield select(selectAllSubjects());
  const currentSubject= allSubjects && allSubjects[0] && allSubjects[0].subject;
  try {
    if(currentSubject)
    {
      yield put(mkFetchTeacherDashboardOverviewData(currentSubject));    
    }
  } catch (e) {
    console.log(e.message);
  }
}

function* initPrincipalDashboard(action) {
  const allSubjects =  yield select(selectAllSubjects());
  const currentSubject= allSubjects && allSubjects[0] && allSubjects[0].subject;
  try {
    if(currentSubject)
    {
      if(!isNaN(action.school_id) && action.school_id !== null)
      {
        API.setPrincipalSchoolId(action.school_id);
      }
      yield put(mkFetchPrincipalDashboardOverviewData(currentSubject));    
    }
  } catch (e) {
    console.log(e.message);
  }
}

function* fetchMinistryDashboardOverviewData(action) {
  const currentSubject = action.subject;
  try {
    const resp = yield call(API.fetchMinistryDashboardOverviewData,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
        payload: resp.data,
      });
      yield put(mkFetchTeacherEngagementCount(currentSubject));
      yield put(mkFetchTeacherEngagementData(currentSubject));
      yield put(mkFetchStudentEngagementCount(currentSubject));
      yield put(mkFetchStudentEngagementData(currentSubject));
      yield put(mkFetchStudentProficientLvlTwoCount(currentSubject));
      yield put(mkFetchStudentProficientLvlTwoData(currentSubject));
      yield put(mkFetchStudentProficientLvlTwoCount(currentSubject, undefined, 2));
      yield put(mkFetchStudentProficientLvlTwoData(currentSubject, undefined , 2));
      yield put(mkFetchMinistryTotalQuestionsAttemptCount(currentSubject));
      yield put(mkFetchMinistryTotalQuestionsAttemptData(currentSubject));
      yield put(mkFetchMinistryTotalQuestionsAttemptCount(currentSubject, undefined, 2));
      yield put(mkFetchMinistryTotalQuestionsAttemptData(currentSubject, undefined , 2));
      yield put(mkFetchMinistryStudentImprovementCount(currentSubject));
      yield put(mkFetchMinistryStudentImprovementData(currentSubject));
      yield put(mkFetchMinistryStudentImprovementCount(currentSubject, undefined, 2));
      yield put(mkFetchMinistryStudentImprovementData(currentSubject, undefined, 2));
    } else {
      yield put({
        type: FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherEngagementCount(action) {
  try {
 const resp = yield call(API.fetchTeacherEngagementCount,action.subject,action.district);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_ENGAGEMENT_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_ENGAGEMENT_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherEngagementData(action) {
  try {
  const resp = yield call(API.fetchTeacherEngagementData,action.subject,action.district);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_ENGAGEMENT_DATA_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_ENGAGEMENT_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_ENGAGEMENT_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentEngagementCount(action) {
  try {
 const resp = yield call(API.fetchStudentEngagementCount,action.subject,action.district);

    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_STUDENT_ENGAGEMENT_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_ENGAGEMENT_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentEngagementData(action) {
  try {
 const resp = yield call(API.fetchStudentEngagementData,action.subject,action.district);

    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_ENGAGEMENT_DATA_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_STUDENT_ENGAGEMENT_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_ENGAGEMENT_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentProficientLvlTwoCount(action) {
  try {
 const resp = yield call(API.fetchStudentProficientLvlTwoCount,action.subject,action.district, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchStudentProficientLvlTwoData(action) {
  try {
const resp = yield call(API.fetchStudentProficientLvlTwoData,action.subject,action.district, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_PROFICIENT_LVL_2_DATA_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_STUDENT_PROFICIENT_LVL_2_DATA_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_PROFICIENT_LVL_2_DATA_FAILED,
      message: e.message, 
      round: action.round
    });
  }
}

export function* fetchMinistryTotalQuestionsAttemptCount(action) {
  try {
  const resp = yield call(API.fetchMinistryTotalQuestionsAttemptCount,action.subject,action.district, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchMinistryTotalQuestionsAttemptData(action) {
  try {
 const resp = yield call(API.fetchMinistryTotalQuestionsAttemptData,action.subject,action.district, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchMinistryStudentImprovementCount(action) {
  try {
    const resp = yield call(API.fetchMinistryStudentImprovementCount,action.subject,action.district, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchMinistryStudentImprovementData(action) {
  try {
    const resp = yield call(API.fetchMinistryStudentImprovementData,action.subject,action.district, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchTeacherEngagementPercentageTable(action) {
  try {
   const resp = yield call(API.fetchTeacherEngagementPercentageTable,action.subject,action.district,action.school,action.sortVal,action.limit,action.offset);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherEngagementHoursTable(action) {
  try {
    const resp = yield call(API.fetchTeacherEngagementHoursTable,action.subject,action.district,action.format,action.school,action.sortVal,action.limit,action.offset);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentEngagementPercentageTable(action) {
  try {
    const resp = yield call(API.fetchStudentEngagementPercentageTable,action.subject,action.district,action.school,action.sortVal,action.limit,action.offset);

    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentEngagementHoursTable(action) {
  try {
    const resp = yield call(API.fetchStudentEngagementHoursTable,action.subject,action.district,action.school,action.sortVal,action.limit,action.offset);

    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentProficientLvlTwoPercentTable(action) {
  try {
    const resp = yield call(API.fetchStudentProficientLvlTwoPercentTable,action.subject,action.district,action.school,action.sortVal,action.limit,action.offset, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchStudentProficientLvlTwoNumberTable(action) {
  try {
   const resp = yield call(API.fetchStudentProficientLvlTwoNumberTable,action.subject,action.district,action.school,action.sortVal,action.limit,action.offset, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchMinistryStudentImprovementPercentageTable(action) {
  try {
   const resp = yield call(API.fetchMinistryStudentImprovementPercentageTable,action.subject,action.district,action.school,action.sortVal,action.limit,action.offset,action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchMinistryStudentImprovementNumberTable(action) {
  try {
    const resp = yield call(API.fetchMinistryStudentImprovementNumberTable,action.subject,action.district,action.school,action.sortVal,action.limit,action.offset,action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_FAILED,
      message: e.message,
      round: action.round
    });
  }
}


export function* fetchMinistryQuestionsAttemptedTable(action) {
  try {
  const resp = yield call(API.fetchMinistryQuestionsAttemptedTable,action.subject,action.district,action.school,action.sortVal,action.limit,action.offset,action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchStudentDashboardOverviewData(action) {
  try {
    const resp = yield call(API.fetchStudentDashboardOverviewData, action.class_code);
    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
      yield put(mkFetchStudentTimeChartData(action.class_code));
      yield put(mkFetchStudentQuestionCompletionChartData(action.class_code));
      yield put(mkFetchStudentImprovementChartData(action.class_code));
    } else {
      yield put({
        type: FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_FAILED,
      message: e.message,
      round: action.round
    });
  }
}
export function* fetchStudentDashboardOverviewDataRoundTwo(action) {
  try {
    const resp = yield call(API.fetchStudentDashboardOverviewData, action.class_code, 2);
    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_SUCCEEDED,
        payload: resp.data,
      });
      yield put(mkFetchStudentQuestionCompletionChartData(action.class_code,undefined, 2));
      yield put(mkFetchStudentImprovementChartData(action.class_code,undefined, 2));
    } else {
      yield put({
        type: FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentTimeChartData(action) {
  try {
    const resp = yield call(API.fetchStudentTimeChartData, action.class_code,action.filter_class);
    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_TIME_CHART_DATA_SUCCEEDED,
        payload: resp.data.data,
      });
    } else {
      yield put({
        type: FETCH_STUDENT_TIME_CHART_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_TIME_CHART_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentQuestionCompletionChartData(action) {
  try {
    const resp = yield call(API.fetchStudentQuestionCompletionChartData, action.class_code,action.filter_class, action.round);
    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_SUCCEEDED,
        payload: resp.data.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchStudentImprovementChartData(action) {
  try {
    const resp = yield call(API.fetchStudentImprovementChartData, action.class_code,action.filter_class, action.round);
    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_IMPROVEMENT_CHART_DATA_SUCCEEDED,
        payload: resp.data.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_STUDENT_IMPROVEMENT_CHART_DATA_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_IMPROVEMENT_CHART_DATA_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchStudentTimeData(action) {
  try {
    const resp = yield call(API.fetchStudentTimeData, action.class_code,action.format);
    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_TIME_DATA_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_STUDENT_TIME_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_TIME_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentQuestionCompletionData(action) {
  try {
    const resp = yield call(
      API.fetchStudentQuestionCompletionData,
      action.class_code,
      action.round
    );
    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_QUESTION_COMPLETION_DATA_SUCCEEDED,
        payload: resp.data,
        round : action.round
      });
    } else {
      yield put({
        type: FETCH_STUDENT_QUESTION_COMPLETION_DATA_FAILED,
        resp,
        round : action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_QUESTION_COMPLETION_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentImprovementData(action) {
  try {
    const resp = yield call(API.fetchStudentImprovementData, action.class_code, action.round);
    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_IMPROVEMENT_DATA_SUCCEEDED,
        payload: resp.data,
        round : action.round
      });
    } else {
      yield put({
        type: FETCH_STUDENT_IMPROVEMENT_DATA_FAILED,
        resp,
        round : action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_IMPROVEMENT_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentDetailedImprovementData(action) {
  try {
    const resp = yield call(
      API.fetchStudentDetailedImprovementData,
      action.class_code,
      action.student_id,
      action.round
    );
    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_SUCCEEDED,
        payload: resp.data,
        round : action.round
      });
    } else {
      yield put({
        type: FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_FAILED,
        resp,
        round : action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_FAILED,
      message: e.message,
      round : action.round
    });
  }
}

export function* fetchStudentTopicCompletedQuestionData(action) {
  try {
    const resp = yield call(
      API.fetchStudentTopicCompletedQuestionData,
      action.class_code,
      action.student_id,
      action.topic_id,

    );
    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED,
        payload: resp.data,
        studentId: action.student_id
      });
      yield put(mkFetchStudentPracticeReportQuestions(action.class_code,resp.data.attempts));
    } else {
      yield put({
        type: FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentTriesQuestionData(action) {
  try {
    const resp = yield call(
      API.fetchStudentTriesQuestionData,
      action.class_code,
      action.student_id,
     action.topic_id,
    action.try_count
    );
    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED,
        payload: resp.data,
        studentId: action.student_id
      });
      yield put(mkFetchStudentImprovementReportQuestions(action.class_code,resp.data.attempts));
    } else {
      yield put({
        type: FETCH_STUDENT_TRIES_QUESTIONS_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_TRIES_QUESTIONS_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentPracticeReportQuestions(action) {
  const {attempt_ids} = action;
  let i=0;
  try {
    for (; i < attempt_ids.length; i++) {
      let resp;
      try {
        resp = yield call(API.fetchStudentPracticeReportQuestions,action.class_code, attempt_ids[i]);
      } catch (e) {
        yield put({
          type: FETCH_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
          index: i,
          message: e.message,
        });
        continue;
      }
             while (resp.status >= 400 && resp.status !== 401) {
          resp = yield call(API.fetchStudentPracticeReportQuestions, action.class_code,attempt_ids[i]);
        }
        if (resp.status < 400) {
          yield put({
            type: FETCH_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED,
            index: i,
            data: resp.data,
          });    
        }
        else
        {
          yield put({
            type: FETCH_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
            index: i,
            resp,
          });
        }
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
      message: e.message,
    });
  }
}

export function* fetchStudentImprovementReportQuestions(action) {
  const {attempt_ids} = action;
  let i=0;
  try {
    for (; i < attempt_ids.length; i++) {
      let resp;
      try {
        resp = yield call(API.fetchStudentImprovementReportQuestions, action.class_code, attempt_ids[i]);
      } catch (e) {
        yield put({
          type: FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
          index: i,
          message: e.message,
        });
        continue;
      }
             while (resp.status >= 400 && resp.status !== 401) {
          resp = yield call(API.fetchStudentImprovementReportQuestions, action.class_code, attempt_ids[i]);
        }
        if (resp.status < 400) {
          yield put({
            type: FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED,
            index: i,
            data: resp.data,
          });    
        }
        else
        {
          yield put({
            type: FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
            index: i,
            resp,
          });
        }
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
      message: e.message,
    });
  }
}

function* fetchTeacherDashboardOverviewData(action) {
  try {
    const resp = yield call(API.fetchTeacherDashboardOverviewData,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardNationwideStudentEngagementCount(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardNationwideStudentEngagementCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED,
      message: e.message,
    });
  }
}


export function* fetchTeacherDashboardNationwideStudentEngagementChart(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardNationwideStudentEngagementChart,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardNationwideStudentProfLvlTwoCount(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardNationwideStudentProfLvlTwoCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardNationwideStudentProfLvlTwoChart(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardNationwideStudentProfLvlTwoChart,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED,
      message: e.message,
    });
  }
}
export function* fetchTeacherDashboardNationwideStudentProfLvlThreeCount(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardNationwideStudentProfLvlThreeCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardNationwideStudentProfLvlThreeChart(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardNationwideStudentProfLvlThreeChart,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardStudentEngagementCount(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardStudentEngagementCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardStudentEngagementChart(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardStudentEngagementChart,action.subject,action.filter_class);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardStudentCompletedTwentyQuestionsCount(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardStudentCompletedTwentyQuestionsCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardStudentCompletedTwentyQuestionsChart(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardStudentCompletedTwentyQuestionsChart,action.subject,action.filter_class);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED,
      message: e.message,
    });
  }
}
export function* fetchTeacherDashboardStudentCompletedTenQuestionsCount(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardStudentCompletedTenQuestionsCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardStudentCompletedTenQuestionsChart(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardStudentCompletedTenQuestionsChart,action.subject,action.filter_class);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED
        ,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardStudentProfLvlTwoCount(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardStudentProfLvlTwoCount,action.subject, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED,
        resp,
        round: action.round,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED,
      message: e.message,
      round: action.round,
    });
  }
}

export function* fetchTeacherDashboardStudentProfLvlTwoChart(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardStudentProfLvlTwoChart,action.subject,action.filter_class, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED,
        resp,
        round: action.round,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED,
      message: e.message,
      round: action.round,
    });
  }
}

export function* fetchTeacherDashboardStudentImprovementCount(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardStudentImprovementCount,action.subject, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED,
        resp,
        round: action.round,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED,
      message: e.message,
      round: action.round,
    });
  }
}

export function* fetchTeacherDashboardStudentImprovementChart(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardStudentImprovementChart,action.subject,action.filter_class, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED,
        resp,
        round: action.round,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED,
      message: e.message,
      round: action.round,
    });
  }
}

export function* fetchTeacherDashboardStudentHoursTable(action) {
  try {
   const resp = yield call(API.fetchTeacherDashboardStudentHoursTable,action.subject,action.time_format,action.filter_class,action.student_name,action.limit,action.offset);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardStudentQuestionsCompletedTable(action) {
  try {
  const resp = yield call(API.fetchTeacherDashboardStudentQuestionsCompletedTable,action.subject,action.filter_class,action.student_name,action.limit,action.offset, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED,
        payload: resp.data,
        round : action.round,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED,
        resp,
        round : action.round,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED,
      message: e.message,
      round : action.round,
    });
  }
}

export function* fetchTeacherDashboardStudentProfLvlTwoTable(action) {
  
  try {  
    const resp = yield call(API.fetchTeacherDashboardStudentProfLvlTwoTable,action.subject,action.filter_class,action.student_name,action.limit,action.offset, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED,
        resp,
        round: action.round,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED,
      message: e.message,
      round: action.round,
    });
  }
}

export function* fetchTeacherDashboardStudentImprovementTable(action) {
  try {
    const resp = yield call(API.fetchTeacherDashboardStudentImprovementTable,action.subject,action.filter_class,action.student_name,action.limit,action.offset, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED,
        resp,
        round: action.round,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED,
      message: e.message,
      round: action.round,
    });
  }
}

export function* fetchTeacherDashboardStudentDetailedImprovementTable(action) {
  try {  
    const resp = yield call(API.fetchTeacherDashboardStudentDetailedImprovementTable,action.subject,action.student_id,action.filter_class, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED,
        resp,
        round: action.round,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED,
      message: e.message,
      round: action.round,
    });
  }
}

export function* fetchTeacherDashboardQuestionAnalysisTopics(action) {
  try {
    const resp = yield call(API.fetchTeacherDashboardQuestionAnalysisTopics,action.subject,action.filter_class, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchTeacherDashboardQuestionAnalysisChart(action) {
  try {
    const resp = yield call(API.fetchTeacherDashboardQuestionAnalysisChart,action.subject,action.filter_class, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchTeacherDashboardStudentTopicCompletedQuestionData(action) {
  try {
    const resp = yield call(
      API.fetchTeacherDashboardStudentTopicCompletedQuestionData,
      action.subject,
      action.student_id,
      action.topic_id,

    );
    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED,
        payload: resp.data,
        studentId: action.student_id
      });
      yield put(mkFetchTeacherDashboardStudentPracticeReportQuestions( action.subject,resp.data.attempts));
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardStudentTriesQuestionData(action) {
  try {
    const resp = yield call(
      API.fetchTeacherDashboardStudentTriesQuestionData,
      action.subject,
      action.student_id,
      action.topic_id,
      action.try_count
    );
    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED,
        payload: resp.data,
        studentId: action.student_id
      });
      yield put(mkFetchTeacherDashboardStudentImprovementReportQuestions( action.subject,resp.data.attempts));
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardStudentPracticeReportQuestions(action) {
  const {attempt_ids} = action;
  let i=0;
  try {
    for (; i < attempt_ids.length; i++) {
      let resp;
      try {
        resp = yield call(API.fetchTeacherDashboardStudentPracticeReportQuestions,action.subject, attempt_ids[i]);
      } catch (e) {
        yield put({
          type: FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
          index: i,
          message: e.message,
        });
        continue;
      }
             while (resp.status >= 400 && resp.status !== 401) {
          resp = yield call(API.fetchTeacherDashboardStudentPracticeReportQuestions, action.subject,attempt_ids[i]);
        }
        if (resp.status < 400) {
          yield put({
            type: FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED,
            index: i,
            total_attempts:attempt_ids.length,
            data: resp.data,
          });    
        }
        else
        {
          yield put({
            type: FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
            index: i,
            resp,
          });
        }
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardStudentImprovementReportQuestions(action) {
  const {attempt_ids} = action;
  let i=0;
  try {
    for (; i < attempt_ids.length; i++) {
      let resp;
      try {
        resp = yield call(API.fetchTeacherDashboardStudentImprovementReportQuestions, action.subject, attempt_ids[i]);
      } catch (e) {
        yield put({
          type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
          index: i,
          message: e.message,
        });
        continue;
      }
        while (resp.status >= 400 && resp.status !== 401) {
          resp = yield call(API.fetchTeacherDashboardStudentImprovementReportQuestions, action.subject, attempt_ids[i]);
        }
        if (resp.status < 400) {
          yield put({
            type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED,
            index: i,
            total_attempts:attempt_ids.length,
            data: resp.data,
          });    
        }
        else
        {
          yield put({
            type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
            index: i,
            resp,
          });
        }
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
      message: e.message,
    });
  }
}

export function* fetchTeacherDashboardQuestionAnalysisTable(action) {
  try {    
    const resp = yield call(API.fetchTeacherDashboardQuestionAnalysisTable,action.subject,action.filter_class,action.topic_id, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round,
      });
    } else {
      yield put({
        type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED,
        resp,
        round: action.round,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED,
      message: e.message,
      round: action.round,
    });
  }
}

export function* fetchStudentListDropdown(action) {
  try {    
    const resp = yield call(API.fetchStudentListDropdown,action.subject,action.filter_class, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_STUDENT_LIST_DROPDOWN_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_STUDENT_LIST_DROPDOWN_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_STUDENT_LIST_DROPDOWN_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

function* fetchPrincipalDashboardOverviewData(action) {
  const currentSubject = action.subject;
  try {
    const resp = yield call(API.fetchPrincipalDashboardOverviewData,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardNationwideTeacherEngagementCount(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardNationwideTeacherEngagementCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_FAILED,
      message: e.message,
    });
  }
}


export function* fetchPrincipalDashboardNationwideTeacherEngagementChart(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardNationwideTeacherEngagementChart,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardNationwideStudentEngagementCount(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardNationwideStudentEngagementCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED,
      message: e.message,
    });
  }
}


export function* fetchPrincipalDashboardNationwideStudentEngagementChart(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardNationwideStudentEngagementChart,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardNationwideStudentProfLvlTwoCount(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardNationwideStudentProfLvlTwoCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardNationwideStudentProfLvlTwoChart(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardNationwideStudentProfLvlTwoChart,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardNationwideStudentProfLvlThreeCount(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardNationwideStudentProfLvlThreeCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardNationwideStudentProfLvlThreeChart(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardNationwideStudentProfLvlThreeChart,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardTeacherEngagementCount(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardTeacherEngagementCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardTeacherEngagementChart(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardTeacherEngagementChart,action.subject,action.filter_class);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentEngagementCount(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentEngagementCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentEngagementChart(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentEngagementChart,action.subject,action.filter_class);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentCompletedTwentyQuestionsCount(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentCompletedTwentyQuestionsCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentCompletedTwentyQuestionsChart(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentCompletedTwentyQuestionsChart,action.subject,action.filter_class);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentCompletedTenQuestionsCount(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentCompletedTenQuestionsCount,action.subject);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentCompletedTenQuestionsChart(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentCompletedTenQuestionsChart,action.subject,action.filter_class);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentProfLvlTwoCount(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentProfLvlTwoCount,action.subject, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchPrincipalDashboardStudentProfLvlTwoChart(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentProfLvlTwoChart,action.subject,action.filter_class, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchPrincipalDashboardStudentImprovementCount(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentImprovementCount,action.subject, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchPrincipalDashboardStudentImprovementChart(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentImprovementChart,action.subject,action.filter_class, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchPrincipalDashboardTeacherHoursTable(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardTeacherHoursTable,action.subject,action.time_format,action.filter_class,action.teacher_name,action.limit,action.offset);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentHoursTable(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentHoursTable,action.subject,action.time_format,action.filter_class,action.student_name,action.limit,action.offset);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentQuestionsCompletedTable(action) {
  try {
  const resp = yield call(API.fetchPrincipalDashboardStudentQuestionsCompletedTable,action.subject,action.filter_class,action.student_name,action.limit,action.offset, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchPrincipalDashboardStudentProfLvlTwoTable(action) {
  
  try {  
    const resp = yield call(API.fetchPrincipalDashboardStudentProfLvlTwoTable,action.subject,action.filter_class,action.student_name,action.limit,action.offset, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchPrincipalDashboardStudentImprovementTable(action) {
  try {
    const resp = yield call(API.fetchPrincipalDashboardStudentImprovementTable,action.subject,action.filter_class,action.student_name,action.limit,action.offset, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchPrincipalDashboardStudentDetailedImprovementTable(action) {
  try {
    const resp = yield call(API.fetchPrincipalDashboardStudentDetailedImprovementTable,action.subject,action.student_id,action.filter_class, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchPrincipalDashboardQuestionAnalysisChart(action) {
  try {
    
    const resp = yield call(API.fetchPrincipalDashboardQuestionAnalysisChart,action.subject,action.filter_class, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchPrincipalDashboardQuestionAnalysisTopics(action) {
  try {
    const resp = yield call(API.fetchPrincipalDashboardQuestionAnalysisTopics,action.subject,action.filter_class, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED,
      message: e.message,
      round: action.round

    });
  }
}

export function* fetchPrincipalDashboardQuestionAnalysisTable(action) {
  try {
    const resp = yield call(API.fetchPrincipalDashboardQuestionAnalysisTable,action.subject,action.filter_class,action.topic_id, action.round);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED,
        payload: resp.data,
        round: action.round
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED,
        resp,
        round: action.round
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED,
      message: e.message,
      round: action.round
    });
  }
}

export function* fetchPrincipalDashboardStudentTopicCompletedQuestionData(action) {
  try {
    const resp = yield call(
      API.fetchPrincipalDashboardStudentTopicCompletedQuestionData,
      action.subject,
      action.student_id,
      action.topic_id,

    );
    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED,
        payload: resp.data,
        studentId: action.student_id
      });
      yield put(mkFetchPrincipalDashboardStudentPracticeReportQuestions( action.subject,resp.data.attempts));
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentTriesQuestionData(action) {
  try {
    const resp = yield call(
      API.fetchPrincipalDashboardStudentTriesQuestionData,
      action.subject,
      action.student_id,
      action.topic_id,
      action.try_count
    );
    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED,
        payload: resp.data,
        studentId: action.student_id
      });
      yield put(mkFetchPrincipalDashboardStudentImprovementReportQuestions( action.subject,resp.data.attempts));
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentPracticeReportQuestions(action) {
  const {attempt_ids} = action;
  let i=0;
  try {
    for (; i < attempt_ids.length; i++) {
      let resp;
      try {
        resp = yield call(API.fetchPrincipalDashboardStudentPracticeReportQuestions,action.subject,attempt_ids[i]);
      } catch (e) {
        yield put({
          type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
          index: i,
          message: e.message,
        });
        continue;
      }
             while (resp.status >= 400 && resp.status !== 401) {
          resp = yield call(API.fetchPrincipalDashboardStudentPracticeReportQuestions, action.subject,attempt_ids[i]);
        }
        if (resp.status < 400) {
          yield put({
            type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED,
            index: i,
            total_attempts:attempt_ids.length,
            data: resp.data,
          });    
        }
        else
        {
          yield put({
            type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
            index: i,
            resp,
          });
        }
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentImprovementReportQuestions(action) {
  const {attempt_ids} = action;
  let i=0;
  try {
    for (; i < attempt_ids.length; i++) {
      let resp;
      try {
        resp = yield call(API.fetchPrincipalDashboardStudentImprovementReportQuestions, action.subject, attempt_ids[i]);
      } catch (e) {
        yield put({
          type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
          index: i,
          message: e.message,
        });
        continue;
      }
             while (resp.status >= 400 && resp.status !== 401) {
          resp = yield call(API.fetchPrincipalDashboardStudentImprovementReportQuestions, action.subject, attempt_ids[i]);
        }
        if (resp.status < 400) {
          yield put({
            type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED,
            index: i,
            total_attempts:attempt_ids.length,
            data: resp.data,
          });    
        }
        else
        {
          yield put({
            type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
            index: i,
            resp,
          });
        }
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED,
      message: e.message,
    });
  }
}

export function* fetchPrincipalDashboardStudentListDropdown(action) {
  try {    
    const resp = yield call(API.fetchPrincipalDashboardStudentListDropdown,action.subject,action.filter_class);

    if (resp.status < 400) {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_FAILED,
      message: e.message,
    });
  }
}

export function* fetchDistrictSchools(action) {
  try {
    const resp = yield call(API.fetchDistrictSchools,action.limit,action.offset,action.name,action.district);

    if (resp.status < 400) {
      yield put({
        type: FETCH_DISTRICT_SCHOOLS_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_DISTRICT_SCHOOLS_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_DISTRICT_SCHOOLS_FAILED,
      message: e.message,
    });
  }
}

export function* fetchDistricts(action) {
  try {
    const resp = yield call(API.fetchDistricts,action.limit,action.offset,action.name);

    if (resp.status < 400) {
      yield put({
        type: FETCH_DISTRICTS_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: FETCH_DISTRICTS_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: FETCH_DISTRICTS_FAILED,
      message: e.message,
    });
  }
}

export function* downloadDistrictData(action) {
  try {
    const resp = yield call(API.downloadDistrictData,action.district,action.country);

    if (resp.status < 400) {
      yield put({
        type: DOWNLOAD_DISTRICT_DATA_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: DOWNLOAD_DISTRICT_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: DOWNLOAD_DISTRICT_DATA_FAILED,
      message: e.message,
    });
  }
}

export function* downloadAllMOEReports(action){
  try {
    const resp = yield call(API.downloadAllMOEReports,action.subject, action.language, action.AllMoeReportsDownloadPayloadData);

    if (resp.status < 400) {
      yield put({
        type: DOWNLOAD_ALL_MOE_REPORTS_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: DOWNLOAD_ALL_MOE_REPORTS_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: DOWNLOAD_ALL_MOE_REPORTS_FAILED,
      message: e.message,
    });
  }
}
export function* downloadPaginationData(action) {
  try {
    const resp = yield call(API.downloadPaginationData,action.param,action.subject,action.language,action.metricName, action.topic, action.round);

    if (resp.status < 400) {
      yield put({
        type: DOWNLOAD_PAGINATION_DATA_SUCCEEDED,
        payload: resp.data,
      });
    } else {
      yield put({
        type: DOWNLOAD_PAGINATION_DATA_FAILED,
        resp,
      });
    }
  } catch (e) {
    yield put({
      type: DOWNLOAD_PAGINATION_DATA_FAILED,
      message: e.message,
    });
  }
}


export default function* rootSaga() {
  yield all([
    takeLatest(GET_USER_LOGIN_REQUESTED,loginUser),
    takeLatest(INIT_APP, initApp),
    takeLatest(GET_ME_REQUESTED, getMe),
    takeLatest(GET_USER_REFRESH_REQUESTED, getUserRefresh),
    takeLatest(USER_LOGGED_OUT, userLoggedOut),
    takeLatest(GET_USER_LOGOUT_REQUESTED, getUserLogout),
    takeLatest(GET_USER_PASSWORD_LINK_REQUESTED, forgotPassword),
    takeLatest(RESET_PASSWORD_REQUESTED, resetPassword),
    takeLatest(VERIFY_RESET_CODE_REQUESTED, verifyResetCode),
    takeLatest(GET_CHANGE_PASSWORD_REQUESTED, changePassword),
    takeLatest(INIT_MOE_DASHBOARD, initMOEDashboard),
    takeLatest(FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_REQUESTED,fetchMinistryDashboardOverviewData),
    takeLatest(FETCH_TEACHER_ENGAGEMENT_COUNT_REQUESTED,fetchTeacherEngagementCount),
    takeLatest(FETCH_TEACHER_ENGAGEMENT_DATA_REQUESTED,fetchTeacherEngagementData),
    takeLatest(FETCH_STUDENT_ENGAGEMENT_COUNT_REQUESTED,fetchStudentEngagementCount),
    takeLatest(FETCH_STUDENT_ENGAGEMENT_DATA_REQUESTED,fetchStudentEngagementData),
    takeLatest(FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_REQUESTED,fetchStudentProficientLvlTwoCount),
    takeLatest(FETCH_STUDENT_PROFICIENT_LVL_2_DATA_REQUESTED,fetchStudentProficientLvlTwoData),
    takeLatest(FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_REQUESTED2,fetchStudentProficientLvlTwoCount),
    takeLatest(FETCH_STUDENT_PROFICIENT_LVL_2_DATA_REQUESTED2,fetchStudentProficientLvlTwoData),
    takeLatest(FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_REQUESTED,fetchMinistryTotalQuestionsAttemptCount),
    takeLatest(FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_REQUESTED,fetchMinistryTotalQuestionsAttemptData),
    takeLatest(FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_REQUESTED2,fetchMinistryTotalQuestionsAttemptCount),
    takeLatest(FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_REQUESTED2,fetchMinistryTotalQuestionsAttemptData),
    takeLatest(FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_REQUESTED,fetchMinistryStudentImprovementCount),
    takeLatest(FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_REQUESTED,fetchMinistryStudentImprovementData),
    takeLatest(FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_REQUESTED2,fetchMinistryStudentImprovementCount),
    takeLatest(FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_REQUESTED2,fetchMinistryStudentImprovementData),
    takeLatest(FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_REQUESTED,fetchTeacherEngagementPercentageTable),
    takeLatest(FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_REQUESTED,fetchTeacherEngagementHoursTable),
    takeLatest(FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_REQUESTED,fetchStudentEngagementPercentageTable),
    takeLatest(FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_REQUESTED,fetchStudentEngagementHoursTable),
    takeLatest(FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_REQUESTED,fetchStudentProficientLvlTwoPercentTable),
    takeLatest(FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_REQUESTED,fetchStudentProficientLvlTwoNumberTable),
    takeLatest(FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_REQUESTED,fetchMinistryStudentImprovementPercentageTable),
    takeLatest(FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_REQUESTED,fetchMinistryStudentImprovementNumberTable),
    takeLatest(FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_REQUESTED,fetchMinistryQuestionsAttemptedTable),
    takeLatest(INIT_STUDENT_DASHBOARD,initStudentDashboard),
    takeLatest(FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_REQUESTED,fetchStudentDashboardOverviewData),
    takeLatest(FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_REQUESTED,fetchStudentDashboardOverviewDataRoundTwo),
    takeLatest(FETCH_STUDENT_TIME_CHART_DATA_REQUESTED, fetchStudentTimeChartData),
    takeLatest(FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_REQUESTED, fetchStudentQuestionCompletionChartData),
    takeLatest(FETCH_STUDENT_IMPROVEMENT_CHART_DATA_REQUESTED, fetchStudentImprovementChartData),
    takeLatest(FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_REQUESTED2, fetchStudentQuestionCompletionChartData),
    takeLatest(FETCH_STUDENT_IMPROVEMENT_CHART_DATA_REQUESTED2, fetchStudentImprovementChartData),
    takeLatest(FETCH_STUDENT_TIME_DATA_REQUESTED, fetchStudentTimeData),
    takeLatest(FETCH_STUDENT_QUESTION_COMPLETION_DATA_REQUESTED,fetchStudentQuestionCompletionData),
    takeLatest(FETCH_STUDENT_IMPROVEMENT_DATA_REQUESTED,fetchStudentImprovementData),
    takeLatest(FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_REQUESTED,fetchStudentDetailedImprovementData),
    takeLatest(FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED,fetchStudentTopicCompletedQuestionData),
    takeLatest(FETCH_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED, fetchStudentTriesQuestionData),
    takeLatest(FETCH_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED,fetchStudentPracticeReportQuestions),
    takeLatest(FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED,fetchStudentImprovementReportQuestions),
    takeLatest(INIT_TEACHER_DASHBOARD,initTeacherDashboard),

    takeLatest(FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_REQUESTED,fetchTeacherDashboardOverviewData),

    takeLatest(FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_REQUESTED,fetchTeacherDashboardNationwideStudentEngagementCount),
    takeLatest(FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_REQUESTED,fetchTeacherDashboardNationwideStudentEngagementChart),
    takeLatest(FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_REQUESTED,fetchTeacherDashboardNationwideStudentProfLvlTwoCount),
    takeLatest(FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_REQUESTED,fetchTeacherDashboardNationwideStudentProfLvlTwoChart),
    takeLatest(FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_REQUESTED,fetchTeacherDashboardNationwideStudentProfLvlThreeCount),
    takeLatest(FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_REQUESTED,fetchTeacherDashboardNationwideStudentProfLvlThreeChart),


    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_REQUESTED,fetchTeacherDashboardStudentEngagementCount),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_REQUESTED,fetchTeacherDashboardStudentEngagementChart),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_REQUESTED,fetchTeacherDashboardStudentCompletedTwentyQuestionsCount),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_REQUESTED,fetchTeacherDashboardStudentCompletedTwentyQuestionsChart),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_REQUESTED,fetchTeacherDashboardStudentCompletedTenQuestionsCount),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_REQUESTED,fetchTeacherDashboardStudentCompletedTenQuestionsChart),


    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED,fetchTeacherDashboardStudentProfLvlTwoCount),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED,fetchTeacherDashboardStudentProfLvlTwoChart),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED,fetchTeacherDashboardStudentImprovementCount),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED,fetchTeacherDashboardStudentImprovementChart),

    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED2,fetchTeacherDashboardStudentProfLvlTwoCount),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED2,fetchTeacherDashboardStudentProfLvlTwoChart),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED2,fetchTeacherDashboardStudentImprovementCount),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED2,fetchTeacherDashboardStudentImprovementChart),

    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_REQUESTED,fetchTeacherDashboardStudentHoursTable),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_REQUESTED,fetchTeacherDashboardStudentQuestionsCompletedTable),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_REQUESTED,fetchTeacherDashboardStudentProfLvlTwoTable),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_REQUESTED,fetchTeacherDashboardStudentImprovementTable),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_REQUESTED,fetchTeacherDashboardStudentDetailedImprovementTable),

    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED,fetchTeacherDashboardStudentTopicCompletedQuestionData),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED,fetchTeacherDashboardStudentTriesQuestionData),

    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED,fetchTeacherDashboardStudentPracticeReportQuestions),
    takeLatest(FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED,fetchTeacherDashboardStudentImprovementReportQuestions),

    takeLatest(FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED,fetchTeacherDashboardQuestionAnalysisTopics),
    takeLatest(FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED,fetchTeacherDashboardQuestionAnalysisChart),
    takeLatest(FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED2,fetchTeacherDashboardQuestionAnalysisChart),
    takeLatest(FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_REQUESTED,fetchTeacherDashboardQuestionAnalysisTable),

    takeLatest(FETCH_STUDENT_LIST_DROPDOWN_REQUESTED,fetchStudentListDropdown),

    takeLatest(INIT_PRINCIPAL_DASHBOARD,initPrincipalDashboard),

    takeLatest(FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_REQUESTED,fetchPrincipalDashboardOverviewData),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_REQUESTED,fetchPrincipalDashboardNationwideTeacherEngagementCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_REQUESTED,fetchPrincipalDashboardNationwideTeacherEngagementChart),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_REQUESTED,fetchPrincipalDashboardNationwideStudentEngagementCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_REQUESTED,fetchPrincipalDashboardNationwideStudentEngagementChart),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_REQUESTED,fetchPrincipalDashboardNationwideStudentProfLvlTwoCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_REQUESTED,fetchPrincipalDashboardNationwideStudentProfLvlTwoChart),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_REQUESTED,fetchPrincipalDashboardNationwideStudentProfLvlThreeCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_REQUESTED,fetchPrincipalDashboardNationwideStudentProfLvlThreeChart),

    takeLatest(FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_REQUESTED,fetchPrincipalDashboardTeacherEngagementCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_REQUESTED,fetchPrincipalDashboardTeacherEngagementChart),
    
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_REQUESTED,fetchPrincipalDashboardStudentEngagementCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_REQUESTED,fetchPrincipalDashboardStudentEngagementChart),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_REQUESTED,fetchPrincipalDashboardStudentCompletedTwentyQuestionsCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_REQUESTED,fetchPrincipalDashboardStudentCompletedTwentyQuestionsChart),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_REQUESTED,fetchPrincipalDashboardStudentCompletedTenQuestionsCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_REQUESTED,fetchPrincipalDashboardStudentCompletedTenQuestionsChart),


    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED,fetchPrincipalDashboardStudentProfLvlTwoCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED,fetchPrincipalDashboardStudentProfLvlTwoChart),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED,fetchPrincipalDashboardStudentImprovementCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED,fetchPrincipalDashboardStudentImprovementChart),

    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED2,fetchPrincipalDashboardStudentProfLvlTwoCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED2,fetchPrincipalDashboardStudentProfLvlTwoChart),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED2,fetchPrincipalDashboardStudentImprovementCount),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED2,fetchPrincipalDashboardStudentImprovementChart),

    takeLatest(FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_REQUESTED,fetchPrincipalDashboardTeacherHoursTable),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_REQUESTED,fetchPrincipalDashboardStudentHoursTable),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_REQUESTED,fetchPrincipalDashboardStudentQuestionsCompletedTable),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_REQUESTED,fetchPrincipalDashboardStudentProfLvlTwoTable),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_REQUESTED,fetchPrincipalDashboardStudentImprovementTable),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_REQUESTED,fetchPrincipalDashboardStudentDetailedImprovementTable),

    takeLatest(FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED,fetchPrincipalDashboardQuestionAnalysisTopics),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED2,fetchPrincipalDashboardQuestionAnalysisTopics),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED,fetchPrincipalDashboardQuestionAnalysisChart),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED2,fetchPrincipalDashboardQuestionAnalysisChart),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_REQUESTED,fetchPrincipalDashboardQuestionAnalysisTable),

    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED,fetchPrincipalDashboardStudentTopicCompletedQuestionData),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED,fetchPrincipalDashboardStudentTriesQuestionData),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED,fetchPrincipalDashboardStudentPracticeReportQuestions),
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED,fetchPrincipalDashboardStudentImprovementReportQuestions),
    
    takeLatest(FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_REQUESTED,fetchPrincipalDashboardStudentListDropdown),

    takeLatest(INIT_PISA_DISTRICT_ADMIN_REPORT,initPISADistrictAdminReport),
    takeLatest(FETCH_DISTRICT_SCHOOLS_REQUESTED,fetchDistrictSchools),
    takeLatest(FETCH_DISTRICTS_REQUESTED,fetchDistricts),
    takeLatest(INIT_PISA_COUNTRY_ADMIN_REPORT,initPISACountryAdminReport),
    takeLatest(DOWNLOAD_DISTRICT_DATA_REQUESTED,downloadDistrictData),
    takeLatest(DOWNLOAD_ALL_MOE_REPORTS_REQUESTED,downloadAllMOEReports),
    
    takeLatest(DOWNLOAD_PAGINATION_DATA_REQUESTED,downloadPaginationData),
  ]);
}
